import { ProductType } from './product.type';

export class ProductArrayType {
	recommendedProds: Array<ProductType>;

	constructor(recommendedProds: Array<ProductType>) {
		this.recommendedProds = recommendedProds;
	}
}
